import { useState } from 'react';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  return (
    <div className="pt-20 min-h-screen bg-background-50">
      <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />

      {/* Brand Introduction */}
      <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">关于羁绊创作工坊</h1>
            <div className="w-16 h-1 bg-accent-500 mx-auto mb-5"></div>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">
              我们是一个专注于姐妹情感羁绊创作的文字社区，致力于为写作者与角色扮演爱好者提供深度指南、创作灵感与交流平台
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 items-center">
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-4">我们的理念</h2>
              <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                在「姐妹奴隶」这一看似极端的标签背后，隐藏着人类对深度情感连接的永恒渴望。我们相信，真正打动人心的创作，从来不只是表面的权力关系，而是隐藏在每一个眼神、每一句对白、每一次触碰之下的复杂人性。
              </p>
              <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                羁绊创作工坊成立于2024年，由一群热爱文字创作的姐妹关系研究者共同发起。我们从最初的几人小团体，逐步发展为一个拥有数千名活跃创作者的线上社区。我们的文章、教程和创作资源被广泛引用于小说写作、剧本创作和角色扮演领域。
              </p>
              <p className="text-foreground-700 text-sm leading-relaxed">
                我们坚持「以文学性为底色，以情感真实为核心」的创作原则。每一篇文章都经过严格的审校流程，确保内容既有理论深度，又具备实践指导价值。我们不追逐流量热点，不制造低质内容，只做对创作者真正有帮助的事情。
              </p>
            </div>
            <div className="relative w-full h-64 md:h-80 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20creative%20studio%20workspace%20with%20two%20people%20writing%20at%20wooden%20desk%2C%20bookshelves%20filled%20with%20literature%2C%20soft%20lamp%20light%2C%20artistic%20atmosphere%2C%20cream%20and%20amber%20tones%2C%20fine%20art%20interior%20photography%2C%20elegant%20bohemian%20style&width=800&height=600&seq=about-brand-image&orientation=landscape"
                alt="羁绊创作工坊工作室"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats / Reputation */}
      <section className="w-full bg-background-100 py-12 md:py-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-8 md:mb-10">品牌声誉</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {[
                { value: '200+', label: '原创文章', icon: 'ri-article-line' },
                { value: '15,000+', label: '月活跃读者', icon: 'ri-group-line' },
                { value: '50+', label: '签约作者', icon: 'ri-user-star-line' },
                { value: '98%', label: '读者好评率', icon: 'ri-heart-line' },
              ].map((stat) => (
                <div key={stat.label} className="text-center p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                    <i className={`${stat.icon} text-lg`}></i>
                  </div>
                  <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-1">{stat.value}</div>
                  <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* Testimonials */}
            <div className="mt-10 md:mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {[
                {
                  quote: '羁绊创作工坊的文章彻底改变了我的写作方式。关于情感张力设计的技巧，让我笔下的人物关系变得更加立体和真实。',
                  name: '小雨',
                  role: '网络小说作者',
                },
                {
                  quote: '作为一个角色扮演爱好者，这里的指南给了我巨大的帮助。尤其是关于安全边界和沉浸感塑造的内容，非常专业。',
                  name: '星辰',
                  role: '角色扮演爱好者',
                },
                {
                  quote: '我一直在寻找关于姐妹情感羁绊的深度创作资源，羁绊创作工坊完美地填补了这个空白。每篇文章都值得反复阅读。',
                  name: '林月',
                  role: '剧本创作者',
                },
              ].map((testimonial) => (
                <div key={testimonial.name} className="p-6 bg-background-50 rounded-lg border border-background-200/70">
                  <div className="text-accent-500 mb-3">
                    <i className="ri-double-quotes-l text-2xl"></i>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">{testimonial.quote}</p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-accent-200 flex items-center justify-center">
                      <span className="font-heading text-accent-700 font-bold text-sm">{testimonial.name.charAt(0)}</span>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-800">{testimonial.name}</div>
                      <div className="text-xs text-foreground-400">{testimonial.role}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="max-w-lg mx-auto">
          <div className="text-center mb-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">联系我们</h2>
            <p className="text-foreground-600 text-sm">有任何问题、建议或合作意向，欢迎随时与我们联系</p>
          </div>
          <ContactForm />
        </div>
      </section>
    </div>
  );
}

function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errMsg, setErrMsg] = useState('');
  const [charCount, setCharCount] = useState(0);
  const MAX_CHARS = 500;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      form.reset();
      setCharCount(0);
      return;
    }
    const formData = new FormData(form);
    if (!formData.get('email')?.toString().trim()) return;

    setStatus('loading');
    try {
      const res = await fetch('https://readdy.ai/api/form/d9rc5nue3oq4jqumtveg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      const code = (parsed as { code?: string })?.code;
      const msg = (parsed as { meta?: { message?: string } })?.meta?.message
        || (parsed as { message?: string })?.message
        || '';

      if (res.ok && code === 'OK') {
        setStatus('success');
        form.reset();
        setCharCount(0);
      } else if (!res.ok || msg.includes('spam') || msg.includes('form data is spam')) {
        setStatus('error');
        setErrMsg(msg || '提交失败，请稍后重试');
      } else {
        setStatus('error');
        setErrMsg(msg || '提交失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setErrMsg('网络错误，请检查连接后重试');
    }
  };

  if (status === 'success') {
    return (
      <div className="p-6 bg-accent-100/50 rounded-lg text-center">
        <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-200 text-accent-700 mx-auto mb-4">
          <i className="ri-check-line text-2xl"></i>
        </div>
        <p className="text-accent-700 font-medium mb-2">消息已发送！</p>
        <p className="text-sm text-accent-600">感谢你的来信，我们会在1-2个工作日内回复。</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} data-readdy-form="" className="space-y-4">
      <div>
        <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
        <input
          id="contact-name"
          type="text"
          name="name"
          required
          placeholder="你的名字"
          className="w-full px-4 py-3 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-accent-400 transition-colors duration-200"
        />
      </div>
      <div>
        <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
        <input
          id="contact-email"
          type="email"
          name="email"
          required
          placeholder="your@email.com"
          className="w-full px-4 py-3 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-accent-400 transition-colors duration-200"
        />
      </div>
      <div>
        <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
        <input
          id="contact-subject"
          type="text"
          name="subject"
          required
          placeholder="消息主题"
          className="w-full px-4 py-3 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-accent-400 transition-colors duration-200"
        />
      </div>
      <div>
        <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">内容 ({charCount}/{MAX_CHARS})</label>
        <textarea
          id="contact-message"
          name="message"
          required
          rows={5}
          maxLength={MAX_CHARS}
          placeholder="请输入你的留言内容..."
          onChange={(e) => setCharCount(e.target.value.length)}
          className="w-full px-4 py-3 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-accent-400 transition-colors duration-200 resize-none"
        ></textarea>
      </div>
      <button
        type="submit"
        disabled={status === 'loading'}
        className="w-full py-3 rounded-lg bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 disabled:opacity-60 transition-colors duration-200 whitespace-nowrap cursor-pointer"
      >
        {status === 'loading' ? '发送中...' : '发送消息'}
      </button>
      {status === 'error' && (
        <p className="text-sm text-red-600 text-center">{errMsg || '发送失败，请稍后重试'}</p>
      )}
      <div className="hp-field-wrapper">
        <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" readOnly aria-hidden="true" />
      </div>
    </form>
  );
}